<template>
  <b-badge pill :variant="variant" class="job-status-badge px-3 py-2">
    {{ label }}
  </b-badge>
</template>

<script>
import { statusLabel, statusVariant } from '@/utils/jobPostings'

// Renders the status the API gave us (is_expired included) — never computed.
export default {
  name: 'JobStatusBadge',

  props: {
    job: {
      type: Object,
      required: true,
    },
  },

  computed: {
    label() {
      return statusLabel(this.job)
    },
    variant() {
      return statusVariant(this.job)
    },
  },
}
</script>
